import { render, staticRenderFns } from "./subscribeChain.vue?vue&type=template&id=4421bb0c&scoped=true&"
import script from "./subscribeChain.vue?vue&type=script&lang=js&"
export * from "./subscribeChain.vue?vue&type=script&lang=js&"
import style0 from "./subscribeChain.vue?vue&type=style&index=0&id=4421bb0c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4421bb0c",
  null
  
)

export default component.exports